import React, { useEffect, useState, useContext } from "react";
import CourseHeader from "../../header2/index-two";
import FeatherIcon from "feather-icons-react";
import { Footer2 } from "../../footer2/index";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import Select from "react-select";
import axiosInstance from "../../../services/axiosInstance";
import { AppContext } from "../../../services/AuthContext";
import { userInstutationDatabases } from "../../../services/userService";
import { Helmet } from "react-helmet-async";
import { Testimonial03 } from "../../imagepath";
import JournalCover from "./JournalCover";
import { buildPublicationPath } from "../../../utils/slugify";
import usePageTracking from "../../../hooks/usePageTracking";

import "bootstrap/dist/css/bootstrap.min.css";
import "../../home2/home.css";
import "../../Database/DatabaseAtoZ.css";

// Helpers (DatabaseList üstüne ekle)
const getYearOnly = (value) => {
  if (!value) return "";
  const m = String(value).match(/\d{4}/);
  return m ? m[0] : "";
};
const getTypeLabel = (pub) => pub.publicationtype || "";

const getTypeSpecificFieldsLite = (pub) => {
  const info0 = pub.parentList?.[0]?.publicationtypeInfo || [];
  const info1 = pub.parentList?.[1]?.publicationtypeInfo || [];
  const get = (arr, name) => arr.find(x => x.attributename === name)?.value?.[0]?.value?.[0] || "";
  const dergiAdi = get(info1, "Dergi Adı") || get(info1, "Başlık") || get(info0, "Dergi Adı") || get(info0, "Başlık");
  const cilt = get(info0, "Cilt") || get(pub.publicationtypeInfo || [], "Cilt");
  const sayi = get(info0, "Sayı") || get(pub.publicationtypeInfo || [], "Sayı");
  const yil =
    getYearOnly(
      pub.templateInfo?.find(a => a.attributename === "Yayın Tarihi")?.value?.[0]?.value?.[0] ||
      pub.templateInfo?.find(a => a.attributename === "Son Yayınlandığı Tarih")?.value?.[0]?.value?.[0] ||
      ""
    );
  return [
    dergiAdi && { label: "Dergi adı", value: dergiAdi },
    yil && { label: "Tarih", value: yil },
    cilt && { label: "Cilt", value: `Cilt ${cilt}` },
    sayi && { label: "Sayı", value: `Sayı ${sayi}` },
  ].filter(Boolean);
};


const JournalList = () => {
  usePageTracking("journal-list");
  const navigate = useNavigate();
  const location = useLocation();
  const { auth } = useContext(AppContext);
  const { id } = useParams();

  // --- States First ---
  const [allDBNames, setAllDBNames] = useState(null);
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPublication, setTotalPublication] = useState(0);
  const [filter, setFilter] = useState("");
  const [searchType, setSearchType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");

  const [topics, setTopics] = useState([]);
  const [initialized, setInitialized] = useState(false);
  const [coverError, setCoverError] = useState(false);
  const [viewMode, setViewMode] = useState(() => localStorage.getItem('db_view') || 'grid');

  // --- Derived Values ---
  const isAll = id === 'all';
  const isAkademik = id === 'akademik';
  const isPopuler = id === 'populer';
  const journalType = isAkademik ? 'akademik' : (isPopuler ? 'populer' : (isAll ? 'all' : 'single'));

  const getBannerTitle = () => {
    if (journalType === 'akademik') return "Akademik Dergiler Veritabanı";
    if (journalType === 'populer') return "Popüler Dergiler Veritabanı";
    if (journalType === 'all') return "Süreli Yayınlar Veritabanı";
    if (id) {
      const cleanId = decodeURIComponent(id).trim();
      return /veri\s*taban[ıi]/i.test(cleanId) ? cleanId : `${cleanId} Veritabanı`;
    }
    return "Süreli Yayınlar Veritabanı";
  };



  // Journal-only helpers
  const getTags = (pub) => {
    const extractAttrArr = (list, attrName) => {
      if (!Array.isArray(list)) return [];
      const attr = list.find(a => a.attributename === attrName);
      if (!attr || !attr.value) return [];
      if (Array.isArray(attr.value)) {
        const trVal = attr.value.find(v => v.lang === "tr" && Array.isArray(v.value))?.value;
        if (trVal) return trVal;
        const firstVal = attr.value.find(v => Array.isArray(v.value))?.value;
        if (firstVal) return firstVal;
        if (typeof attr.value[0] === 'string') return attr.value;
      }
      return [];
    };

    // 1. Ek Bilgi (templateInfo)
    const templateTopics = extractAttrArr(pub?.templateInfo, "Konu Başlıkları");
    const templateKeywords = extractAttrArr(pub?.templateInfo, "Anahtar Kelimeler");

    // 2. Ana Kısım / Yayın Türü (publicationtypeInfo)
    const pubTypeTopics = extractAttrArr(pub?.publicationtypeInfo, "Konu Başlıkları");
    const pubTypeKeywords = extractAttrArr(pub?.publicationtypeInfo, "Anahtar Kelimeler");

    // Tümünü birleştir, temizle ve tekrarları kaldır
    const all = [
      ...templateTopics,
      ...pubTypeTopics,
      ...pubTypeKeywords,
      ...templateKeywords,
    ]
      .map(x => (typeof x === "string" ? x.trim() : String(x).trim()))
      .filter(Boolean);

    return Array.from(new Set(all));
  };


  // --- GÜNCELLENMİŞ getJournalFields FONKSİYONU: ISSN/E-ISSN Tekleştirildi ---
  const getJournalFields = (pub) => {
    const publisher = pub.publishers?.[0] || null;

    // Period bilgisi 'period' alanından alınabilir.
    const periyot = pub.period ||
      pub.templateInfo?.find(a => a.attributename === "Periyot")
        ?.value?.[0]?.value?.[0] ||
      pub.publicationtypeInfo?.find(a => a.attributename === "Periyot")
        ?.value?.[0]?.value?.[0] ||
      "";

    // ISSN bilgisi publicationtypeInfo'dan alınır.
    const issnValue =
      pub.publicationtypeInfo?.find(a => a.attributename === "ISSN")
        ?.value?.[0]?.value?.[0] || "";

    const eissnValue =
      pub.publicationtypeInfo?.find(a => a.attributename === "E-ISSN")
        ?.value?.[0]?.value?.[0] || "";

    // ISSN/E-ISSN birleştirme mantığı
    let issnField = null;
    if (issnValue) {
      issnField = { label: "ISSN", value: issnValue }; // ISSN varsa, sadece onu al
    } else if (eissnValue) {
      issnField = { label: "E-ISSN", value: eissnValue }; // ISSN yoksa, E-ISSN'i al
    }


    // Tarih bilgisi için öncelik sırası: publicationtypeInfo -> templateInfo
    const tarihStr = pub.publicationtypeInfo?.find(a => a.attributename === "Yayın Tarihi")
      ?.value?.[0]?.value?.[0] ||
      pub.templateInfo?.find(a => a.attributename === "Son Yayınlandığı Tarih")
        ?.value?.[0]?.value?.[0] ||
      pub.templateInfo?.find(a => a.attributename === "Yayın Tarihi")
        ?.value?.[0]?.value?.[0] ||
      "";

    const tarih = getYearOnly(tarihStr) + "-" || "";

    // Ülke bilgisi
    const country = pub.publicationtypeInfo?.find(a => a.attributename === "Ülke")
      ?.value?.[0]?.value?.[0] || "";


    // Dönen nesneleri güncelledik.
    return [
      publisher && {
        label: "Yayıncı",
        value: publisher.sorttitle || publisher.title,
        href: `/publisher-detail/${publisher.mysqlId}`,
        onClick: () => navigate(`/publisher-detail/${publisher.mysqlId}`)
      },
      periyot && { label: "Periyot", value: periyot },
      country && { label: "Ülke", value: country },
      // issnField, // Sadece bir tane ISSN/E-ISSN alanı eklendi
      tarih && { label: "Tarih", value: tarih },
    ].filter(Boolean);
  };

  const headers = auth.token
    ? { Authorization: `Bearer ${auth.token}` }
    : {};

  useEffect(() => {
    // Sadece 'all' modunda kurum veritabanlarını çek
    if (journalType !== 'all') {
      setAllDBNames([]);
      return;
    }
    let mounted = true;
    (async () => {
      try {
        const resp = await userInstutationDatabases(auth.token);
        const names = (resp?.data || []).map(x => x.name).filter(Boolean);
        if (mounted) setAllDBNames(names);
        // fetchTopics() burundan kaldırıldı; Hook 4 (initialized ve allDBNames bağımlı olan) zaten bunu yapacak.
      } catch (e) {
        if (mounted) setAllDBNames([]);
        console.error("userInstutationDatabases error:", e);
      }
    })();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, [journalType, auth.token]);

  useEffect(() => {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      // fallback for environments where window.scrollTo may not be available
      window.scrollTo(0, 0);
    }
  }, [currentPage]);

  // Görünüm modunu (grid/list) yerel depolama ile senkronize et
  useEffect(() => {
    localStorage.setItem('db_view', viewMode);
  }, [viewMode]);


  // --- Search Debounce ---
  useEffect(() => {
    // harf filtrelemesi (A-Z) için gecikme olmasın
    if (searchType === "journalNameStart") {
      setDebouncedSearchQuery(searchQuery);
      return;
    }

    const handler = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery, searchType]);


  // Dergi tipi değişimini yöneten fonksiyon
  const handleTypeChange = (newType) => {
    // Dergi tipi değişirse konu filtresini varsayılan olarak "Tümü" yap
    setFilter("");

    navigate(`/journal-list/${newType}`, {
      state: {
        databasename: newType,
        searchkeyword: searchQuery,
        searchtype: searchType,
        topicname: ""  // filter temizlendi
      }
    });
  };



  const fetchTopics = async () => {
    try {
      const url = "publicationSearch/journalsTopicsList";

      let list = [];
      if (journalType === 'akademik') {
        list = ["Akademik Dergiler"];
      } else if (journalType === 'populer') {
        list = ["Popüler Dergiler"];
      } else if (journalType === 'all') {
        // ÇÖZÜM: allDBNames boşsa (henüz çekilmemişse), Akademik ve Popüler'i varsayılan olarak gönder.
        // allDBNames dolunca, bu useEffect tekrar tetiklenecek ve gerçek listeyi kullanacaktır.
        list = allDBNames?.length > 0 ? allDBNames : ["Akademik Dergiler", "Popüler Dergiler"];
      } else { // single DB
        list = [id];
      }

      // Eğer liste hala boşsa, konuları çekme
      if (list.length === 0) {
        setTopics([{ value: "", label: "Tümü" }]);
        return;
      }

      // all modunda ve veritabanı isimleri henüz boşsa, API'ye boş liste göndermemek için KONTROLÜ KALDIRDIK.
      // Çünkü yukarıdaki çözümde list artık boş olmayacak (Akademik+Popüler eklendi).
      // Bu kontrol artık gereksiz, hatta yukarıdaki varsayılan mantığı bozuyordu.
      /*
      if (journalType === 'all' && allDBNames.length === 0) {
        setTopics([{ value: "", label: "Tümü" }]);
        return;
      }
      */


      const response = await axiosInstance.post(
        url,
        { list },
        { headers: { ...headers, "Content-Type": "application/json" } }
      );

      if (response?.data?.status === "OK") {
        const formattedTopics = (response.data.data || []).map((t) => ({
          value: t.key,
          label: `${t.key} (${t.value})`,
        }));
        formattedTopics.unshift({ value: "", label: "Tümü" });
        setTopics(formattedTopics);
      } else {
        setTopics([{ value: "", label: "Tümü" }]);
      }
    } catch (error) {
      console.error("Error fetching topics:", error);
      setTopics([{ value: "", label: "Tümü" }]);
    }
  };


  const fetchPublications = async (page = 1) => {
    setLoading(true);
    try {
      const url = `publicationSearch/AtoZJournals?page=${page}`;

      // API'ye gönderilecek veritabanı isimlerini journalType'a göre belirle
      let dbNamesForApi = [];
      if (journalType === 'akademik') {
        dbNamesForApi = ["Akademik Dergiler"];
      } else if (journalType === 'populer') {
        dbNamesForApi = ["Popüler Dergiler"];
      } else if (journalType === 'all') {
        // ÇÖZÜM: allDBNames boşsa (henüz çekilmemişse), Akademik ve Popüler'i varsayılan olarak gönder.
        // allDBNames dolunca, bu useEffect tekrar tetiklenecek ve gerçek listeyi kullanacaktır.
        dbNamesForApi = allDBNames?.length > 0 ? allDBNames : ["Akademik Dergiler", "Popüler Dergiler"];
      } else { // single DB
        dbNamesForApi = [id];
      }

      // Hâlâ boş liste gelirse (ancak artık sadece özel/tekil durumlar için geçerli olmalı)
      if (dbNamesForApi.length === 0) {
        setLoading(false);
        return;
      }


      let searchkeyword = searchQuery || "";
      const typeForApi = searchkeyword ? (searchType || "journalName") : "journalName";

      const params = {
        databasename: dbNamesForApi,
        searchkeyword,
        topicname: filter || "",
        searchtype: typeForApi,
      };

      const response = await axiosInstance.post(url, params, { headers });
      if (response.data && response.data.status === "OK") {
        setPublications(response.data.data);
        const totalItems = response.data.count || 0;
        setTotalPublication(totalItems);
        setTotalPages(Math.ceil(totalItems / 20));
      } else {
        setPublications([]);
        setTotalPublication(0);
        setTotalPages(1);
      }
    } catch (error) {
      console.error("Error fetching publications:", error);
      setPublications([]);
      setTotalPublication(0);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };



  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchPublications(page);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setSearchType("journalName");
    // setFilter("");
    setCurrentPage(1);
  };

  const handleFilter = (char) => {
    if (char === "") {
      setSearchType("");
      setSearchQuery("");
    } else {
      setSearchType("journalNameStart");
    }
    setSearchQuery(char);
    setCurrentPage(1);
  };

  const handleTopicChange = (selectedOption) => {
    setFilter(selectedOption?.value || "");
    setCurrentPage(1);
  };

  const getMatchingTitle = (pub, filter) => {
    const titleAttribute = pub.publicationtypeInfo?.find(
      (attr) => attr.attributename === "Başlık"
    );

    if (!titleAttribute || !Array.isArray(titleAttribute.value)) return "-";

    const trTitles = titleAttribute.value.filter(item => item.lang === 'tr');
    const enTitles = titleAttribute.value.filter(item => item.lang === 'en');
    const firstTitle = titleAttribute.value[0];

    // Arama tipi journalNameStart ise filtre harfine göre kontrol yap
    if (searchType === "journalNameStart" && filter) {
      const regexp = new RegExp(`^${filter}`, "i");
      let trMatch = null;

      // Türkçe başlıklarda filtreyle başlayan var mı?
      for (const item of trTitles) {
        if (item.value && item.value[0] && regexp.test(item.value[0])) {
          trMatch = item.value[0];
          break;
        }
      }

      // Eğer Türkçe başlık eşleşmiyorsa İngilizceye bak
      if (!trMatch) {
        for (const item of enTitles) {
          if (item.value && item.value[0] && regexp.test(item.value[0])) {
            return item.value[0];
          }
        }
      }

      // Türkçe başlık eşleştiyse onu döndür
      if (trMatch) return trMatch;
    }

    // Normal durumda (veya journalNameStart değilse)
    if (trTitles.length > 0) {
      const tr = trTitles[0].value?.[0];
      if (tr) return tr;
    }

    // Eğer Türkçe yoksa İngilizceyi al
    if (enTitles.length > 0) {
      const en = enTitles[0].value?.[0];
      if (en) return en;
    }

    // En son fallback olarak ilk başlık
    if (firstTitle?.value?.[0]) return firstTitle.value[0];

    return "-";
  };


  const renderPagination = () => {
    if (totalPages <= 1) return null;
    // CourseList'tekiyle birebir aynı pagination:
    const maxPageButtons = 10;
    let startPage = Math.max(1, currentPage - 5);
    let endPage = Math.min(totalPages, startPage + maxPageButtons - 1);
    if (endPage - startPage < maxPageButtons - 1) {
      startPage = Math.max(1, endPage - maxPageButtons + 1);
    }
    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return (
      <ul className="pagination lms-page justify-content-center d-flex gap-1">
        {/* İlk Sayfa */}
        <li className={`page-item first ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="btn btn-outline-primary btn-sm text-xs me-2"
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          >
            {"<<"}
          </button>
        </li>
        {/* Önceki */}
        <li className={`page-item prev ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="btn btn-outline-primary btn-sm text-xs me-2"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <i className="fas fa-angle-left" />
          </button>
        </li>
        {/* Sayfa Numaraları */}
        {pageNumbers.map((page) => (
          <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
            <button
              className={`btn btn-sm text-xs me-2 ${currentPage === page ? "bg-primary text-white" : "btn-outline-primary"}`}
              onClick={() => handlePageChange(page)}
              disabled={currentPage === page}
            >
              {page}
            </button>
          </li>
        ))}
        {/* Sonraki */}
        <li className={`page-item next ${currentPage === totalPages ? "disabled" : ""}`}>
          <button
            className="btn btn-outline-primary btn-sm text-xs me-2"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <i className="fas fa-angle-right" />
          </button>
        </li>
        {/* Son Sayfa */}
        <li className={`page-item last ${currentPage === totalPages ? "disabled" : ""}`}>
          <button
            className="btn btn-outline-primary btn-sm text-xs me-2"
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          >
            {">>"}
          </button>
        </li>
      </ul>
    );
  };

  useEffect(() => {
    if (location.state) {
      const { databasename, searchkeyword, topicname, searchtype } = location.state;
      // location.state sadece başlangıç filtrelerini ayarlar,
      // URL'deki `id` parametresinin değişmesi journalType'ı günceller ve fetch'i tetikler.
      if (databasename) {
        if (id === databasename || (isAll && databasename === 'all') || (isAkademik && databasename === 'akademik') || (isPopuler && databasename === 'populer')) {
          setSearchQuery(searchkeyword || "");
          setSearchType(searchtype || "");
          setFilter(topicname || "");
          setCurrentPage(1);
        }
      } else if (searchkeyword || isAll) {
        setSearchQuery(searchkeyword || "");
        setSearchType(searchtype || "journalName");
        setFilter(topicname || "");
        setCurrentPage(1);
      }
      setInitialized(true);
    } else {
      setInitialized(true);
    }
    // eslint-disable-next-line
  }, [location.state, id]);

  useEffect(() => {
    // Sadece başlangıç değerleri set edildikten ve (all modunda) veritabanı isimleri geldikten sonra çalış.
    if (!initialized || (journalType === 'all' && allDBNames === null)) return;

    fetchPublications(currentPage);
    // eslint-disable-next-line
  }, [id, journalType, filter, searchType, debouncedSearchQuery, auth.token, currentPage, initialized, allDBNames]);

  useEffect(() => {
    // Sadece başlangıç değerleri set edildikten ve (all modunda) veritabanı isimleri geldikten sonra çalış.
    if (!initialized || (journalType === 'all' && allDBNames === null)) return;

    fetchTopics();
    // eslint-disable-next-line
  }, [id, initialized, auth.token, journalType, allDBNames]); 

  const renderPublication = (pub, index) => {
    const title = getMatchingTitle(pub, searchQuery);
    const authorsArr = pub.authors || [];
    const tags = getTags(pub);
    const fields = getJournalFields(pub);

    const seoPath = buildPublicationPath({
      title: title, // getMatchingTitle'dan gelen temiz başlık
      id: pub.mysqlId
    });

    const coverImage = pub.coverimage
      ? `https://idealonline.com.tr/service/idealonline/v1/publications/search/displayFile/${pub.mysqlId}/${pub.coverimage}`
      : Testimonial03;

    // --- MetaLine BİLEŞENİ ---
    const MetaLine = () => (
      <div className="mb-2 text-darkfume small" style={{ fontSize: '0.95em' }}>
        {fields.map((f, i) => {
          // f.value null/undefined ise atla
          if (!f.value) return null;

          let displayValue = f.value;
          // Eğer alan etiketi ISSN veya E-ISSN ise, değeri "ETİKET: [değer]" şeklinde formatla
          if (f.label === "ISSN" || f.label === "E-ISSN") {
            displayValue = `${f.label}: ${f.value}`;
          }

          return f.href ? (
            <a
              key={i}
              href={f.href}
              className="text-darkfume"
              style={{ textDecoration: 'none', padding: '0 1px' }}
              onClick={(e) => { e.preventDefault(); f.onClick && f.onClick(); }}
              onMouseOver={(e) => (e.currentTarget.style.textDecoration = "underline")}
              onMouseOut={(e) => (e.currentTarget.style.textDecoration = "none")}
            >
              {displayValue}{i < fields.length - 1 ? ' | ' : ''}
            </a>
          ) : (
            <span key={i}>{displayValue}{i < fields.length - 1 ? ' | ' : ''}</span>
          )
        })}
      </div>
    );
    // --- MetaLine BİLEŞENİ SONU ---

    if (viewMode === 'grid') {
      return (
        <div className="col-md-6 col-lg-4 col-xl-3" key={index}>
          <div className="card h-100 shadow-sm border rounded-3 bg-white">
            {coverImage && (
              <div className="col-auto p-3">
                <Link to={seoPath}>
                  <JournalCover
                    mysqlId={pub.mysqlId}
                    defaultCover={Testimonial03}
                  />
                </Link>
              </div>
            )}
            <div className="card-body pb-2">
              <h5 className="card-title text-newdarkfume text-sm fw-bold mb-2" style={{ minHeight: 40 }}>
                <Link
                  to={seoPath}
                  className="text-newdarkfume text-decoration-none"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              </h5>

              {/* (opsiyonel) yazarlar varsa göster */}
              {/* {authorsArr.length > 0 && (
                <div className="mb-1 text-darkfume text-sm">
                  <b>Yazarlar:</b> {authorsArr.map(a => `${a.name} ${a.surname}`).join(", ")}
                </div>
              )} */}

              <MetaLine />

              {/* tags */}
              <div className="mb-1">
                {tags.map((t, i) => (
                  <span
                    key={i}
                    className="badge bg-light border text-newdarkfume me-1 small"
                    style={{ fontWeight: 500, border: "1px solid #e0e2f5" }}
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      );
    }

    // LIST view (PublicationCard benzeri)
    return (
      <div className="col-12" key={index}>
        <div className="card shadow-sm border rounded-3 bg-white">
          <div className="row g-0 align-items-center">
            {coverImage && (
              <div className="col-auto p-3">
                <Link to={seoPath}>
                  <JournalCover
                    mysqlId={pub.mysqlId}
                    defaultCover={Testimonial03}
                  />
                </Link>
              </div>
            )}
            <div className="col">
              <div className="card-body py-3">
                <h6 className="mb-1 fw-semibold">
                  <Link
                    to={seoPath}
                    className="text-newdarkfume text-decoration-none"
                    dangerouslySetInnerHTML={{ __html: title }}
                  />
                </h6>

                {/* {authorsArr.length > 0 && (
                  <div className="text-darkfume text-sm mb-1">
                    <b>Yazarlar:</b> {authorsArr.map(a => `${a.name} ${a.surname}`).join(", ")}
                  </div>
                )} */}

                <MetaLine />
              </div>
            </div>
            <div className="col-auto pe-3">
              <Link to={seoPath} className="btn btn-sm btn-outline-newdarkfumetogreen rounded">
                Detay
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  };



  return (
    <div className="main-wrapper">
      <Helmet>
        <title>İdealonline - {getBannerTitle()}</title>
      </Helmet>
      <CourseHeader activeMenu={"CourseList"} />
      <section className="py-5 mt-4">
        <div className="dblist-container">
          <div className="row justify-content-center mb-4">
            <div className="col-12">
              <div className="modern-search-banner rounded-2 mb-4">
                <div className="row g-4">

                  {/* Sol Widget Wrap: Başlık, Açıklama, Form */}
                  <div className="col-lg-9 col-md-8">

                    <h2 className="search-banner-title">{getBannerTitle()}</h2>
                    <p className="search-banner-description">Dergi adı, konu veya anahtar kelimeyle arama yaparak aradığınız içeriklere hızla ulaşın.</p>

                    {/* --- YENİ Dergi Tipi Seçim Butonları --- */}
                    {/* <div className="d-flex justify-content-center gap-3 mb-4 border-bottom pb-3">
                  <button
                    className={`btn  ${journalType === 'akademik' ? 'btn-primary text-white' : 'btn-outline-primary text-darkfume'}`}
                    onClick={() => handleTypeChange('akademik')}
                  >
                    Akademik Dergiler
                  </button>
                  <button
                    className={`btn  ${journalType === 'populer' ? 'btn-primary text-white' : 'btn-outline-primary text-darkfume'}`}
                    onClick={() => handleTypeChange('populer')}
                  >
                    Popüler Dergiler
                  </button>
                  <button
                    className={`btn  ${journalType === 'all' ? 'btn-primary text-white' : 'btn-outline-primary text-darkfume'}`}
                    onClick={() => handleTypeChange('all')}
                  >
                    Tüm Süreli Yayınlar
                  </button>
                </div> */}
                    {/* --- Dergi Tipi Seçim Butonları SONU --- */}

                    <div className="filter-listing-form">
                      <div className="row g-2 align-items-center">
                        {/* 1️⃣ Dergi Adı Arama */}
                        <div className="col-md-6">
                          <div className="input-group">
                            <span className="input-group-text bg-white border-0">
                              <FeatherIcon icon="search" className="text-darkfume" />
                            </span>
                            <input
                              type="text"
                              className="form-control border-0"
                              placeholder="Yayın ismi ile arayın..."
                              value={searchType === "journalNameStart" ? "" : searchQuery}
                              onChange={handleSearch}
                              style={{ minHeight: 44 }}
                            />

                          </div>
                        </div>

                        {/* 2️⃣ Konu Seçiniz */}
                        <div className="col-md-3">
                          <Select
                            options={topics}
                            placeholder="Konu"
                            onChange={handleTopicChange}
                            value={topics.find(t => t.value === filter) || ""}
                            // isClearable
                            classNamePrefix="react-select"
                            styles={{ control: (base) => ({ ...base, minHeight: 50, borderRadius: 8 }) }}
                          />

                        </div>

                        {/* 3️⃣ Dergi Türü Seçiniz */}
                        <div className="col-md-3">
                          <Select
                            options={[
                              { value: "akademik", label: "Akademik Dergiler" },
                              { value: "populer", label: "Popüler Dergiler" },
                              { value: "all", label: "Tüm Süreli Yayınlar" },
                            ]}
                            placeholder="Dergi Türü Seçiniz"
                            value={
                              journalType === "akademik"
                                ? { value: "akademik", label: "Akademik Dergiler" }
                                : journalType === "populer"
                                  ? { value: "populer", label: "Popüler Dergiler" }
                                  : { value: "all", label: "Tüm Süreli Yayınlar" }
                            }
                            onChange={(selected) => handleTypeChange(selected?.value || "all")}
                            classNamePrefix="react-select"
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: 44,
                                borderRadius: 6,
                                fontSize: '0.95rem'
                              }),
                            }}
                          />
                        </div>
                      </div>
                    </div>


                  </div>

                  {/* Sağ Widget Wrap: A-Z Filtresi */}
                  <div className="col-lg-3 col-md-4 d-flex justify-content-end align-items-center">
                    <div className="ideal-az-grid">
                      {"ABCÇDEFGHIİJKLMNOÖPQRSŞTUÜVWXYZ".split("").map((char) => (
                        <button
                          key={char}
                          className={`az-letter-button ${searchQuery === char && searchType === "journalNameStart" ? "active active-char" : ""}`}
                          onClick={() => handleFilter(char)}
                        >
                          {char}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Sonuç Sayısı ve Görünüm Seçici (YENİ KONUM) */}
            <div className="d-flex align-items-center gap-2 mt-5">
              <div className="text-sm fw-semibold text-muted">
                Toplam {totalPublication} sonuç bulundu.
              </div>
              <div className="ms-auto btn-group" role="group" aria-label="View switcher">
                <button
                  type="button"
                  className={`btn btn-sm ${viewMode === 'grid' ? 'btn-newdarkfume' : 'btn-outline-newdarkfume'}`}
                  onClick={() => setViewMode('grid')}
                  title="Grid view"
                >
                  <FeatherIcon icon="grid" className="me-1" /> Grid
                </button>
                <button
                  type="button"
                  className={`btn btn-sm ${viewMode === 'list' ? 'btn-newdarkfume' : 'btn-outline-newdarkfume'}`}
                  onClick={() => setViewMode('list')}
                  title="List view"
                >
                  <FeatherIcon icon="list" className="me-1" /> Liste
                </button>
              </div>
            </div>
          </div>

          <div className={`row ${viewMode === 'grid' ? 'g-4' : 'gy-0'}`}>
            {loading ? (
              <div className="col-12 text-center my-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Yükleniyor...</span>
                </div>
                <p className="mt-2 text-darkfume">Yayınlar yükleniyor...</p>
              </div>
            ) : publications.length === 0 ? (
              <div className="col-12">
                <div className="alert alert-danger text-center mt-4 rounded-4">
                  Aradığınız kriterlere uygun sonuç bulunamadı.
                </div>
              </div>
            ) : (
              publications.map(renderPublication)
            )}
          </div>


          <div className="row mt-4">
            <div className="col-12 d-flex justify-content-center">
              {renderPagination()}
            </div>
          </div>
        </div>
      </section>

      <Footer2 />
    </div>
  );
};

export default JournalList;